import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Consulting Rooms
export interface ConsultingRoom {
  id: string;
  name: string;
  clinic_id: string;
  status: number;
}

export async function fetchConsultingRooms(clinicId: string): Promise<ConsultingRoom[]> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/consulting-rooms/?clinic_id=${clinicId}`
  );

  if (!response.ok) {
    throw new Error('Erro ao buscar consultórios');
  }

  const data = await response.json();
  return data.items ?? data;
}

